import { devWarn, devError } from "@/lib/log";
/**
 * Copy text to the clipboard in any environment (incl. iframes / restricted
 * contexts where navigator.clipboard is not available).
 * Falls back to a hidden <textarea> + document.execCommand("copy").
 * Returns true on success, false on failure.
 */
export async function copyToClipboard(text) {
  if (!text) return false;

  // Try the modern API first
  if (typeof navigator !== "undefined" && navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // Clipboard API can fail in iframes / restricted contexts — fall back below
      if (process.env.NODE_ENV !== "production") {
        devWarn("navigator.clipboard.writeText failed, using fallback:", err);
      }
    }
  }

  // Fallback: hidden textarea + execCommand
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.opacity = "0";
    ta.style.pointerEvents = "none";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      devError("Clipboard fallback (textarea+execCommand) failed:", err);
    }
    return false;
  }
}
